import { render, staticRenderFns } from "./swipperList.vue?vue&type=template&id=b169bc06"
import script from "./swipperList.vue?vue&type=script&lang=js"
export * from "./swipperList.vue?vue&type=script&lang=js"
import style0 from "./swipperList.vue?vue&type=style&index=0&id=b169bc06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports